import React from "react";
import { Row, Col, Card, Button, Table, Typography } from "antd";
import "./Approval_Button.css"
const { Text, Title } = Typography;

const PM_Report = () => {
  const tableData = [
    {
      key: "1",
      mspc: "KARWAR",
      pusthiLDPE: "290 Kg Covers",
      pusthiHDPE: "116B Mother Bags",
      jaggeryLDPE: "290 Kg Covers",
      overallLDPE: "13.39 T",
      overallHDPE: "3000 Bags",
    },
    {
      key: "2",
      mspc: "KARWAR",
      pusthiLDPE: "290 Kg Covers",
      pusthiHDPE: "116B Mother Bags",
      jaggeryLDPE: "290 Kg Covers",
      overallLDPE: "13.39 T",
      overallHDPE: "3000 Bags",
    },
    {
      key: "3",
      mspc: "KARWAR",
      pusthiLDPE: "290 Kg Covers",
      pusthiHDPE: "116B Mother Bags",
      jaggeryLDPE: "290 Kg Covers",
      overallLDPE: "13.39 T",
      overallHDPE: "3000 Bags",
    },
  ];

  const columns = [
    { title: "MSPC", dataIndex: "mspc", key: "mspc",
      render:(text)=>(
        <span
          style={{
             background: "#E5F9FA",
            color: "#000",
            padding: "2px 14px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >{text}</span>
      ) },
    { title: "Pushti ML LDPE", dataIndex: "pusthiLDPE", key: "pusthiLDPE" },
    { title: "Pushti ML HDPE", dataIndex: "pusthiHDPE", key: "pusthiHDPE" },
    { title: "Jaggery LDPE", dataIndex: "jaggeryLDPE", key: "jaggeryLDPE" },
    {
      title: "OVERALL LDPE",
      dataIndex: "overallLDPE",
      key: "overallLDPE",
      render: (text) => (
        <span
          style={{
             background: "#E5F9FA",
            color: "#000",
            padding: "2px 14px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "OVERALL HDPE",
      dataIndex: "overallHDPE",
      key: "overallHDPE",
      render: (text) => (
        <span
          style={{
            background: "#E5F9FA",
            color: "#000",
            padding: "2px 14px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          {text}
        </span>
      ),
    },
  ];
  const cardItems = [
    { title: "TOTAL MSPC", value: "149" },
    { title: "TOTAL Projects", value: "1,490" },
    { title: "TOTAL Category", value: "6" },
    { title: "Overall FG", value: "2900 T" },
  ];

  
  const detailCardItems = [
    { title: "Pushti", value: "100 T"},
    { title: "MLC", value: "2.3 T" },
    { title: "MLM", value: "2.9 T"  },
    { title: "UPC", value: "20 T"  },
    { title: "UPM", value: "23 T"  },
    { title: "ANC", value: "123 T"  },
    { title: "ANM", value: "98 T" },
  ];

  return (
    
       
      <div style={{ padding: 20, background: "#F5F7FB" }}>

          <Card bordered={false} style={{ borderRadius: "12px", marginBottom: 24, background: "#fff", boxShadow: "0 4px 18px rgba(0,0,0,0.04)" }}>
           <Row gutter={16} align="middle" justify="space-between" style={{ marginBottom: 20 }}>
             <Col>
               <div style={{ color: "#0166B1", fontWeight: "bold" }}>File Name</div>
               <Button
                 disabled
                 style={{
                   border: "1px solid #CCE9FF",
                   borderRadius: "5px",
                   backgroundColor: "#CCE9FF",
                   color: "#000",
                   fontWeight: "bold",
                 }}
               >
                 KTKKAR0825
               </Button>
             </Col>
             <Col>
               <div style={{ color: "#0166B1", fontWeight: "bold" }}>Month</div>
               <Button
                 disabled
                 style={{
                   border: "1px solid #CCE9FF",
                   borderRadius: "5px",
                   backgroundColor: "#CCE9FF",
                   color: "#000",
                   fontWeight: "bold",
                 }}
               >
                 Aug 2025
               </Button>
             </Col>
             <Col>
               <div style={{ color: "#0166B1", fontWeight: "bold" }}>Total Ben.</div>
               <Button
                 disabled
                 style={{
                   border: "1px solid #CCE9FF",
                   borderRadius: "5px",
                   backgroundColor: "#CCE9FF",
                   color: "#000",
                   fontWeight: "bold",
                 }}
               >
                 1234567
               </Button>
             </Col>
             <Col flex="auto" />
             <Col>
               <Button
                className="btn btn-success"
               >
                 Approve
               </Button>
             </Col>
             <Col>
               <Button
                 className="btn btn-warning"
               >
                 Hold
               </Button>
             </Col>
           </Row>
</Card>
      
      <Row gutter={16} style={{ marginBottom: 20 }}>
        {cardItems.map((item, index) => (
          <Col span={6} key={index}>
            <Card
              bordered
              style={{
                textAlign: "center",
                borderRadius: 12,
                position: "relative",
                minHeight:"120",
              }}
            >
          <Title level={4} style={{ marginTop: 20 }}>
                {item.title}
              </Title>
              <Text style={{color:"#0166B1",fontWeight:"bold"}}>{item.value}</Text>
            </Card>
          </Col>
        ))}
      </Row>

      {/*  Second Card Row */}
     <Row gutter={16} style={{ marginBottom: 20 }}>
  {detailCardItems.map((item, index) => (
    <Col flex="1" key={index}>   
      <Card
        bordered
        style={{
          backgroundColor:"#CACACA",
          textAlign: "center",
          borderRadius: 12,
          position: "relative",
          minHeight: 120,   
        }}
      >
        <Title level={4}>
          {item.title}
        </Title>
        <Text style={{ color: "#0166B1" ,fontWeight:"bold"}}>{item.value}</Text>
      </Card>
    </Col>
  ))}
</Row>


     

      
      <Card bordered={false} style={{ borderRadius: "10px" }}>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          bordered={false}
        />
      </Card>
    </div>
  );
};

export default PM_Report;
